// utils/formatProductos.js
export const formatProductos = (response, key) =>
  response.flatMap(item =>
    item[key].map(category => ({
      category: category.categoria,
      slug: category.slug,
      description: category.descripcion,
      products: category.itemProductoCompoent.map(product => ({
        slug: product.slug,
        images: [
          {
            urlDesktop: product.imagenEscritorio?.url,
            urlMobile: product.imagenMobile?.url,
            urlCategory: product.imagenCategoria?.url,
            title: product.nombre,
            description: category.descripcion,
          },
        ],
      })),
    }))
  );
